import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TokenproviderService {

  device: string;
  idUsuario: number;
  usuario: string;
  token: string;

  constructor() { }

  setDevice(device) {
    this.device = device;
  }

  getDevice(){
    return this.device;
  }

  setIdUsuario(idusuario) {
    this.idUsuario = idusuario;
  }

  setToken(token){
    this.token = token;
  }

  getToken() {
    //return btoa(this.device + '|' + this.idUsuario);
    return this.token;
  }

  setUsuario(usuario){
    this.usuario = usuario;
  }

  getUsuario(){
    return this.usuario;
  }
}
